/**
 * OOTB code.
 * DRP-221 removed suggestions hide on click on body, change .siblings to .closest.find
 * DRP-818 hide popular search on resutls injection
 */

'use strict';

const { addClass, hasClass, removeClass, queryFirst, queryAll, renderFragment, getCookieMap, debounce } = require('../domUtil');
const { appendToUrl, setItemInLocalStorage, getItemFromLocalStorage, removeItemFromLocalStorage } = require('../util');
const { HIDDEN_CLASS, KEYCODE_UP, KEYCODE_DOWN, KEYCODE_ENTER, EVENT_KEY_ENTER, SEARCH_TYPE, SEARCH_SUBMIT, SEARCH_SUGGESTIONS, SEARCH_HISTORY, DISPLAY_CLASS, SELECTED_SUGGESTION } = require('../constants');
const { searchHistoryTemplate } = require('lilly/templates');
const minChars = 3;
const DIRECTION_DOWN = 1;
const DIRECTION_UP = -1;
const searchCache = {};
const { body } = document;
const $header = $('header');
const { lp_hsc_enabled: akamaiEnabled, lp_hsc_search: searchCaching, lp_cache_hash: lpCacheHash, lp_group_hash: lpGroupHash } = getCookieMap();
const isCachingEnabled = (akamaiEnabled === 'true' && searchCaching && lpCacheHash && lpGroupHash);
const searchContainer = queryFirst('.js-search-global', body);
const searchField = queryFirst('.search-field', searchContainer);
const LOADING_CLASS = 'm-loading';

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {HTMLElement} element - Search input field DOM element
 * @return {HTMLElement} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(element) {
    const form = element.closest('.search-form');
    return form && queryFirst('.suggestions-wrapper', form);
}


/**
 * Tear down Suggestions panel
 * @param {HTMLElement} element - The target element that prompted this method to fire
 */
function tearDownSuggestions(element) {
    const form = element.closest('form');
    const searchField = queryFirst('input.search-field', form);
    const wrapper = getSuggestionsWrapper(element);
    const suggestions = queryFirst('.search-mobile .suggestions', wrapper);

    searchField.value = '';
    wrapper.textContent = '';

    if (suggestions) {
        delete suggestions.dataset.scrollBound;
        $(suggestions).unbind('scroll');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {HTMLElement} element - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(element) {
    const $element = $(element);

    $('.more-below')[$element.scrollTop() + $element.innerHeight() >= $element[0].scrollHeight ? 'fadeOut' : 'fadeIn']();
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 * @param {HTMLElement} element - The input element associated with this search result.
 * @param {string|boolean} response - HTML string to render or false, if there were no results.
 */
function processResponse(element, response) {
    const wrapper = getSuggestionsWrapper(element);
    const popularSearch = queryFirst('.popular-search');
    const searchErrorMessage = wrapper?.dataset?.errorMessage;
    const query = $(element).val();
    const form = wrapper.closest('form');
    const resetButton = queryFirst('.reset-button', form);
    let suggestionsList = queryFirst('.suggestions', form);

    if (query.length < minChars) { // display default
        addClass(wrapper, HIDDEN_CLASS);
        removeClass(popularSearch, HIDDEN_CLASS);
        element.removeAttribute('aria-describedby');
        removeClass(resetButton, DISPLAY_CLASS);
    }

    addClass(wrapper, LOADING_CLASS); // dim when shown after previous results

    if (response) { // update results
        addClass(resetButton, DISPLAY_CLASS);
        wrapper.textContent = '';
        wrapper.appendChild(renderFragment(response));
        addClass(popularSearch, HIDDEN_CLASS);
        removeClass(wrapper, HIDDEN_CLASS); // display if shown after default
        removeClass(wrapper, LOADING_CLASS); // remove dimming
    }

    if (suggestionsList) {
        element.setAttribute('aria-describedby', 'search-result-count');
    } else {
        element.removeAttribute('aria-describedby');
    }

    const searchSuggestionList = queryAll('.suggestions-section');
    if (searchSuggestionList) {
        searchSuggestionList.forEach(function (elm) {
            elm.addEventListener('click', handleItemClick);
        });
    }
}

/**
 * Show / hide clear btn
 *
 * @param {HTMLElement} element - Search field DOM element
 */
function showHideClearBtn(element) {
    const query = element.value;
    const wrapper = getSuggestionsWrapper(element);
    const clearBtn = queryFirst('.search-form-clear', element.parentElement);

    if (query.length > 0) {
        addClass(clearBtn, DISPLAY_CLASS);
    } else {
        removeClass(clearBtn, DISPLAY_CLASS);
        removeClass(wrapper, 'suggestions-error');
    }
}

/**
 * Retrieve suggestions
 *
 * @param {HTMLElement} element - Search field DOM element
 * @param {Event} e - event that triggered this function call
 */
function getSuggestions(element, e) {
    const query = $(element).val();
    const wrapper = getSuggestionsWrapper(element);
    const msg = `Search results for '${query}'`;

    if (query.length >= minChars) {
        const cacheEntry = searchCache[query];
        if (cacheEntry) {
            processResponse(element, cacheEntry);
            if (e.type === 'keyup' && e.key !== EVENT_KEY_ENTER && e.keyCode !== KEYCODE_ENTER) {
                $(body).trigger('search:suggestionsUpdated');
                announceMessage(msg);
            }
        } else {
            const url = `${wrapper.dataset.url}${encodeURIComponent(query)}`;
            const akamaiUrl = isCachingEnabled ? appendToUrl(url, {
                'lp-cache-hash': lpCacheHash,
                'lp-group-hash': lpGroupHash
            }) : url;

            $.ajax({
                context: element,
                url: akamaiUrl,
                method: 'GET',
                success: function (html) {
                    searchCache[query] = html;
                    processResponse(element, html);
                    $(body).trigger('search:suggestionsUpdated');
                    announceMessage(msg);
                },
                error: function () { }
            });
        }
    }
}

// PT-10593 store search_type in local storage
/**
 * Listen for click on suggested items
 * @param {Event} e - event that triggered this function call
 */
function handleItemClick(e) {
    const target = e.target;
    const suggestionWrapper = target.closest('.suggestions-section');
    const suggestionTypeElem = queryFirst('.suggestions-section-title > span', suggestionWrapper);
    const searchType = suggestionTypeElem ? suggestionTypeElem.textContent.trim().toLowerCase() : SEARCH_SUGGESTIONS;
    setItemInLocalStorage(SEARCH_TYPE, searchType);
    setItemInLocalStorage(SELECTED_SUGGESTION, target.textContent.trim().toLowerCase());
}

/**
 * save search term to the localStorage
 * @param {string} searchText - search term
 * @param {boolean} isRemove - remove item action
 */
function setSearchHistory(searchText, isRemove) {
    if (!searchText) return;

    let searchHistoryStorage = getItemFromLocalStorage(SEARCH_HISTORY) || [];

    // Check if the value already exists in the array and remove it
    const existingIndex = searchHistoryStorage.indexOf(searchText);
    if (~existingIndex) {
        // Remove all existing occurrences of the searchText from the array
        searchHistoryStorage = searchHistoryStorage.filter(item => item !== searchText);
    }

    // don't add recent item to LocalStorage if it is 'remove action'
    if (!isRemove) searchHistoryStorage.unshift(searchText);

    // set max length of the recent search terms
    const maxRecentTerms = queryFirst('.js-search-history')?.dataset?.maxRecentTerms;

    if (searchHistoryStorage.length > maxRecentTerms) {
        // set value to the end of the array if data limit was reached
        searchHistoryStorage = searchHistoryStorage.slice(0, maxRecentTerms);
    }

    setItemInLocalStorage(SEARCH_HISTORY, searchHistoryStorage);
}

/**
 * show recent search history in the Search block
 */
function showSearchHistory() {
    const searchHistoryStorage = getItemFromLocalStorage(SEARCH_HISTORY);
    const searchHistoryEl = queryFirst('.js-search-history');
    if (!searchHistoryStorage || !searchHistoryStorage.length || !searchHistoryEl) return;

    const template = searchHistoryTemplate(
        searchHistoryStorage,
        searchHistoryEl.dataset.baseSearchUrl,
        searchHistoryEl.dataset.clearButtonText,
        searchHistoryEl.dataset.clearTermText
    );
    if (!template) return;

    const listWrapper = document.createElement('div');
    addClass(listWrapper, 'suggestions-search-history-list');
    listWrapper.innerHTML = template;
    searchHistoryEl.appendChild(listWrapper);
    removeClass(searchHistoryEl, HIDDEN_CLASS);
}

/**
 * remove all recent search items
 * @param {HTMLElement} searchHistoryEl - main block element
 */
function removeAllRecents(searchHistoryEl) {
    if (searchHistoryEl) {
        searchHistoryEl.innerHTML = '';
        removeItemFromLocalStorage(SEARCH_HISTORY);
    }
}

module.exports = function () {
    $('form[name="simpleSearch"]').submit(function (e) {
        const suggestionsList = $('.suggestions .item');
        const selectedItems = suggestionsList.filter('.selected');

        if (selectedItems.length) {
            e.preventDefault();
            selectedItems.find('a')[0].click();
        }

        const searchField = queryFirst('.search-field', e.target);
        const searchText = searchField && searchField.value.trim();

        if (searchText) {
            searchField.value = searchText;

            // save searching term after search submit
            setSearchHistory(searchText);
        }

        // trigger same event
        e.target[e.type]();
    });

    const searchFields = queryAll('input.search-field');

    if (searchFields.length) {
        const debounceSuggestions = debounce(getSuggestions, 400, {
            condition: element => !!searchCache[element.value],
            callback: element => processResponse(element, false)
        });

        searchFields.forEach(field => {

            const handleSearchInput = function (e) {
                const { currentTarget } = e;

                // Ignore arrow keys completely to avoid flicker / reflow
                if (e.which === KEYCODE_UP || e.which === KEYCODE_DOWN) {
                    return;
                }

                showHideClearBtn(currentTarget);
                debounceSuggestions(currentTarget, e);
            };

            ['keyup', 'focus'].forEach(eventType => {
                field.addEventListener(eventType, handleSearchInput);
            });

        });

        if (/iPod|iPhone|iPad/.test(navigator.userAgent)) {
            // Only active search input field in use (iOS 18 issue)
            searchField.addEventListener('focus', function () {
                queryAll('input, textarea').forEach(el => {
                    if (el !== searchField) el.setAttribute('readonly', 'readonly');
                });
            });

            queryAll('input, textarea').forEach(el => {
                el.addEventListener('blur', function () {
                    document.querySelectorAll('input, textarea').forEach(el => el.removeAttribute('readonly'));
                });
            });

            queryAll('select').forEach(select => {
                select.setAttribute('tabindex', '-1');
            });
        }
    }

    // DRP-221 removed suggestions hide on click on body
    $(body).on('click touchend', '.search-mobile button.fa-close', e => {
        e.preventDefault();
        $('.suggestions').hide();
        tearDownSuggestions(e.target);
    });

    $('.search-form .reset-button').on('click', function () {
        $(this).removeClass(DISPLAY_CLASS);
        searchField.focus();
    });

    // save searching term after click 'all results for' button
    $(searchContainer).on('click', '.js-search-link', e => {
        const { searchText } = e.target.dataset;
        setSearchHistory(searchText);
    });

    // remove one recent search item
    $(searchContainer).on('click', '.js-remove-recent-search', e => {
        const searchItem = e.target.closest('.js-recent-search-item');
        const searchText = queryFirst('.js-recent-link', searchItem)?.textContent;

        // remove item from local storage
        if (searchText) setSearchHistory(searchText, true);

        // remove item from DOM
        if (searchItem) searchItem.remove();

        // remove text/buttons if it was last removed item
        const searchHistoryEl = queryFirst('.js-search-history');
        if (!queryFirst('.js-recent-search-item', searchHistoryEl)) removeAllRecents(searchHistoryEl);
    });

    // remove all recent search items
    $(searchContainer).on('click', '.js-remove-all-recent', e => {
        removeAllRecents(e.target.closest('.js-search-history'));
    });

    const searchSuggestionList = queryAll('.suggestions-section');
    if (searchSuggestionList) {
        searchSuggestionList.forEach(function (elm) {
            elm.addEventListener('click', handleItemClick);
        });
    }

    showSearchHistory();
};
